import { JIT_MFA_TYPES, SERVICE_ACCOUNTS_PROTOCOLS_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { JitPolicyModel } from './types/JitTypes';
import { FencingPolicyModel } from './types/FencingTypes';

export const JIT_DEFAULT_MIN_ENABLE_HOURS = 1;
export const JIT_DEFAULT_MAX_ENABLE_HOURS = 100;

export const DEFAULT_JIT: JitPolicyModel = {
    protected: false,
    reasonRequired: false,
    disableAfter: JIT_DEFAULT_MIN_ENABLE_HOURS,
    mfaType: JIT_MFA_TYPES.MFA.value,
    tokens: [],
    vendorId: null,
    appId: null
};

export const DEFAULT_FENCING_POLICY: FencingPolicyModel = {
    Protocols: Object.values(SERVICE_ACCOUNTS_PROTOCOLS_OPTIONS),
    Sources: [],
    Destinations: [],
    sendToSiem: false,
    denyAccess: false,
    protected: false,
    allowAllProtocols: true,
    allowAllSources: true,
    allowAllDestinations: true
};
